// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.main-container {
  display: flex;
  flex-direction: column;
}

.data-container {
  margin-top: 1%;
}

.header-text {
  color: #0b2d71;
  font-weight: bolder;
  margin-bottom: 0;
}

hr {
  color: #0b2d71;
  border-top: 0.1em solid;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.table-wrapper {
  overflow-x: auto;
}

.empty-cell {
  background-color: white;
  border: none;
  min-width: 35px;
  max-width: 35px;
  white-space: nowrap;
  font-size: 12px;
}

.empty-cell-bottom-left {
  background-color: white;
  border-bottom: solid 1px #8c8f93;
  border-left: solid 1px #8c8f93;
  min-width: 35px;
  max-width: 35px;
  white-space: nowrap;
  font-size: 12px;
}

.empty-cell-top-left {
  background-color: white;
  border-left: solid 1px #8c8f93;
  min-width: 35px;
  max-width: 35px;
  white-space: nowrap;
  font-size: 12px;
}

.empty-cell-right {
  background-color: white;
  border-bottom: solid 1px #8c8f93;
  min-width: 35px;
  max-width: 35px;
  white-space: nowrap;
  font-size: 12px;
}

.header-branch-size-cell {
  color: #0b2d71;
  font-size: 14px;
  font-weight: 700;
  background-color: white;
  border: solid 2px #8c8f93;
  text-align: center;
  min-width: 35px;
  max-width: 35px;
  white-space: nowrap;
  padding: 4px 2px;
}

.data-cell {
  color: #0b2d71;
  background-color: #edeaea;
  border: solid 2px #8c8f93;
  text-align: center;
  min-width: 35px;
  max-width: 60px;
  white-space: nowrap;
  font-size: 12px;
  padding: 4px 2px;
  vertical-align: middle;
}

.data-cell-changed {
  background-color: #fffcf0;
}

.header-size-label {
  background-color: white;
  text-align: center;
  border-right: solid 1px #8c8f93;
  border-bottom: solid 1px #8c8f93;
  border-left: solid 1px #8c8f93;
  font-size: 12px;
  padding: 4px 2px;
}

.branch-size-label {
  padding: 4px 2px;
  background-color: white;
  text-align: center;
  border: solid 2px #8c8f93;
  font-size: 12px;
}

.rotate-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.rotate-container .rotate-letter {
  display: flex;
  margin: 0;
}
.rotate-container .rotate-letter p {
  transform: rotate(90deg);
  margin: 0;
  font-size: 12px;
}

.branch-cell-old {
  display: block;
  color: #c62828;
  text-decoration: line-through;
  font-weight: 600;
  font-size: 1em;
  line-height: 1.3;
}

.branch-cell-new {
  display: block;
  color: #2e7d32;
  font-weight: 600;
  font-size: 1em;
  line-height: 1.3;
}

.fully-changed-banner {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  padding: 6px 10px;
  background: #fff3e0;
  border-left: 4px solid #e65100;
  border-radius: 2px;
  font-size: 13px;
  color: #bf360c;
}

.fully-changed-icon {
  font-size: 12px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
